/**
 * unidadeItemBuilder — Itens de uma Unidade (Material Didático), BE módulo content.
 *
 * @since fase material-didático unidade-item (2026-07-17)
 */
import type { $Fetch } from 'ofetch';

import { HttpUnidadeItemGateway } from '@/infrastructure/http/HttpUnidadeItemGateway';
import {
  ListUnidadeItens, CreateUnidadeItem, CreateUnidadeItemPdf, CreateUnidadeItemDaBiblioteca,
  ArquivarUnidadeItem, ReordenarUnidadeItens, BaixarUnidadeItem,
} from '@/application/usecase/UnidadeItemUseCaseImpl';

export function buildUnidadeItemSlice(httpClient: $Fetch) {
  const gateway = new HttpUnidadeItemGateway(httpClient);

  const useCases = {
    listUnidadeItens: new ListUnidadeItens(gateway),
    createUnidadeItem: new CreateUnidadeItem(gateway),
    createUnidadeItemPdf: new CreateUnidadeItemPdf(gateway),
    createUnidadeItemDaBiblioteca: new CreateUnidadeItemDaBiblioteca(gateway),
    arquivarUnidadeItem: new ArquivarUnidadeItem(gateway),
    reordenarUnidadeItens: new ReordenarUnidadeItens(gateway),
    baixarUnidadeItem: new BaixarUnidadeItem(gateway),
  };

  return { useCases };
}
